import React from 'react'
import { useState, useRef } from 'react';
import { trackFacebookEvent, trackFacebookCustomEvent } from '../service/facebookPixel';
import { Form, Button, Container, Dropdown, Spinner } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styled, { createGlobalStyle } from 'styled-components';
import "../App.css"

const StyledForm = styled(Form)`
    .form-group-label {
        font-family: Montserrat, sans-serif;
        font-weight: normal;
        font-size: 16px !important;
        color: #b4b0a9;
    }
`;





const EmployeeFormModal = ({show, handleClose, handleSubmitModalForm,handleCloseEmployeeValidationModalValid}) => {

      const [form, setForm] = useState({
        autoRenew: true
    });
      const [errors, setErrors] = useState([]);
      const [errorMessages, setErrorMessages] = useState({})
      const previousErrorsRef = useRef([]);
    //   const previousErrorsRef = React.useRef([]);

        const formRefs = {
              'FIRST NAME': useRef(),
              'LAST NAME': useRef(),
              'EMPLOYEE ID': useRef(),
          };
      

        const handleValidate = async (_form) => {
              const messages = {};
              const errors = [];
              previousErrorsRef.current = [];
              const regex = /^(?=.*[a-zA-Z\sñÑ\s.\s-])[a-zA-Z0-9\sñÑ\s.\s-]+$/;
              const numberRegex = /^\d{6}$/
              const tinRegex = 
                  /^(?!\d*([1-9])\1{3,})(?!0{8,})(?!0123456789)(?!987654321)(?!123456789)\d{14}|00000000000000$/;


             if (!_form.employee_id || !numberRegex.test(_form.employee_id || '')) {
                  errors.push('EMPLOYEE ID');
                  messages['EMPLOYEE ID'] = _form.employee_id ? 'Employee id is invalid' : 'Employee id is required';
              }


              if (!_form.first_name || !regex.test(_form.first_name || '')) {
                  errors.push('FIRST NAME');
                  messages['FIRST NAME'] = !_form.first_name ? 'First name is required' : 'First name is invalid';
              }
    
      
              if (!_form.last_name || !regex.test(_form.last_name || '')) {
                  errors.push('LAST NAME');
                  messages['LAST NAME'] = !_form.last_name ? 'Last name is required' : 'Last name is invalid';
              }
      
      
              if (errors.length) {
     
                  previousErrorsRef.current = errors.slice();
                  setErrors(() => errors);
                  setErrorMessages(() => ({ ...messages }));
                  trackFacebookEvent('Lead', { errorFields: errors });

                  return

             
      
                //   throw new Error('Error on validation', errors);
              }
      
              return;
          };



          const handleInputChange = (e) => {
                
                 const { name, value, type, checked } = e.target;

                 setForm((prevState) => ({
                   ...prevState,
                   [name]: value
                 }));
                console.log(errors)
                console.log(errorMessages)

                if(name  === 'first_name' && value.length > 0) {
           
                   setErrors((prevState) => prevState.filter((error) => error !== 'FIRST NAME'))
                   setErrorMessages((prevState) => {
                   const { 'FIRST NAME': removed, ...rest } = prevState;
                   return rest;
                   });
                }

                if(name  === 'last_name' && value.length > 0) {

                   setErrors((prevState) => prevState.filter((error) => error !== 'LAST NAME'))
                   setErrorMessages((prevState) => {
                   const { 'LAST NAME': removed, ...rest } = prevState;
                   return rest;
                   });
                    
                }   

                 if(name  === 'employee_id' && value.length > 0) {
                   setErrors((prevState) => prevState.filter((error) => error !== 'EMPLOYEE ID'))
                   setErrorMessages((prevState) => {
                   const { 'EMPLOYEE ID': removed, ...rest } = prevState;
                   return rest;
                   });
                }


          }

         const handleResetForm = () => {
               previousErrorsRef.current = []
               setErrors([]);
               setErrorMessages([]);
               handleClose()
               setForm({})
          }


          const handleValidCloseForm = () => {
               previousErrorsRef.current = []
               setErrors([]);
               setErrorMessages([]);
               handleCloseEmployeeValidationModalValid()
               setForm({})
          }


          const handleSubmit  = (e) => {
 
           e.preventDefault();
           e.stopPropagation();

               trackFacebookEvent('SubmitForm', {
                       first_name: form.first_name,
                       last_name: form.last_name,
                       employee_id : form.employee_id
                   });
                
               handleValidate(form)




               if(errors.length === 0) {
                    handleSubmitModalForm(form, handleValidCloseForm)
                    
               }
               

          }


             React.useEffect(() => {

                setForm({
                    employee_id :'',
                    first_name : '',
                    last_name:''

                })

                


                  return () => {
                      setForm(() => null);
                      setErrors(() => []);
                      setErrorMessages(() => ({}));
                  };
              }, []);




                return (
                         <Modal show={show} onHide={handleClose}>
                            <Modal.Title style={{ padding: '3% 8%' }}>Employee information</Modal.Title>
                          <Modal.Body style={{ padding: '3% 8%' }}>
                              <hr /> 
                              <StyledForm>

                                   <Row>
                                           <Col lg={12}>
                                                           <Form.Group className="mb-3">
                                                               <Form.Label
                                                                   className="form-group-label"
                                                                   style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 'normal', fontSize: '14px' }}
                                                               >
                                                                   EMPLOYEE ID
                                                               </Form.Label>
                                                               <Form.Control
                                                                   type="number"
                                                                   name="employee_id"
                                                                   value={form.employee_id}
                                                                   style={{
                                                                       borderColor: (previousErrorsRef?.current ?? []).includes('EMPLOYEE ID')
                                                                           ? 'red'
                                                                           : '',
                                                                       textTransform: 'uppercase'
                                                                       
                                                                   }}
                                                                   onChange={handleInputChange}
                                                                   ref={formRefs['EMPLOYEE ID']}
                                                                   onFocus={() => {
                                                                       const index = previousErrorsRef.current.indexOf('EMPLOYEE ID');
                                                                       if (index !== -1) {
                                                                           const _newArr = previousErrorsRef.current.slice();
                                                                           _newArr.splice(index, 1);
                                                                           previousErrorsRef.current = _newArr;
                                                                       }
                                                                   }}
                                                               />
                                                           </Form.Group>
                                                            <p style={{color:'red'}}>{errorMessages['EMPLOYEE ID']}</p>
                                                       </Col>

                                                        </Row>
                                   
                                                        <Row>
                                                       <Col lg={12}>
                                                           <Form.Group className="mb-3">
                                                               <Form.Label
                                                                   className="form-group-label"
                                                                   style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 'normal', fontSize: '14px' }}
                                                               >
                                                                   FIRST NAME<span>*</span>
                                                               </Form.Label>
                                                               <Form.Control
                                                                   type="text"
                                                                   name="first_name"
                                                                   value={form.first_name}
                                                                   onChange={handleInputChange}
                                                                   required
                                                                   ref={formRefs['FIRST NAME']}
                                                                   style={{
                                                                       borderColor: (previousErrorsRef?.current ?? []).includes('FIRST NAME')
                                                                           ? 'red'
                                                                           : '',
                                                                       textTransform: 'uppercase'
                                                                   }}
                                                                   onFocus={() => {
                                                                       const index = previousErrorsRef.current.indexOf('FIRST NAME');
                                                                       if (index !== -1) {
                                                                           const _newArr = previousErrorsRef.current.slice();
                                                                           _newArr.splice(index, 1);
                                                                           previousErrorsRef.current = _newArr;
                                                                       }
                                                                   }}
                                                               />
                                                           </Form.Group>
                                                             <p style={{color:'red'}}>{errorMessages['FIRST NAME']}</p>
                                                       </Col>
                                                       </Row>
                                   
                                                     <Row>
                                                       <Col lg={12}>
                                                           <Form.Group className="mb-3">
                                                               <Form.Label
                                                                   className="form-group-label"
                                                                   style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 'normal', fontSize: '14px' }}
                                                               >
                                                                   LAST NAME<span>*</span>
                                                               </Form.Label>
                                                               <Form.Control
                                                                   type="text"
                                                                   name="last_name"
                                                                   value={form.last_name}
                                                                   onChange={handleInputChange}
                                                                   required
                                                                   ref={formRefs['LAST NAME']}
                                                                   style={{
                                                                       borderColor: (previousErrorsRef?.current ?? []).includes('LAST NAME') ? 'red' : '',
                                                                       textTransform: 'uppercase'
                                                                   }}
                                                                   onFocus={() => {
                                                                       const index = previousErrorsRef.current.indexOf('LAST NAME');
                                                                       if (index !== -1) {
                                                                           const _newArr = previousErrorsRef.current.slice();
                                                                           _newArr.splice(index, 1);
                                                                           previousErrorsRef.current = _newArr;
                                                                       }
                                                                   }}
                                                               />
                                                           </Form.Group>
                                                               <p style={{color:'red'}}>{errorMessages['LAST NAME']}</p>
                                                       </Col>
                                                   </Row>
                                                   
                                   
                             </StyledForm>
                             <hr />

                             </Modal.Body>

                                         <Modal.Footer style={{ border: 'none' }}>

                                             <Button
                                                                variant="secondary"
                                                                style={{ border: 'none', fontFamily: 'Montserrat, sans-serif', padding: '10px 15px', marginRight: '10px' }}
                                                                onClick={() => handleResetForm()}
                                                            >
                                                                Cancel
                                                            </Button>
                                                            <Button
                                                                variant="primary"
                                                                style={{
                                                                    background: '#f2d841',
                                                                    color: 'black',
                                                                    border: 'none',
                                                                    fontFamily: 'Montserrat, sans-serif',
                                                                    padding: '10px 15px'
                                                                }}

                                                                onClick={(e) => handleSubmit(e)}
                                                            >
                                                                Confirm
                                                            </Button>
                                         </Modal.Footer>


                                       
                         </Modal>
              
                )
              }

export default EmployeeFormModal